import React from 'react';
const books = [{
  num: '1',
  title: 'Frühstück & Smoothies',
  desc: 'Starten Sie jeden Tag mit stabiler Energie — ohne Blutzuckerspitzen am Morgen.'
}, {
  num: '2',
  title: 'Leichte Hauptgerichte',
  desc: 'Mittag- und Abendessen, die sättigen und schmecken — ohne den Blutzucker in die Höhe zu treiben.'
}, {
  num: '3',
  title: 'Vegetarische Lieblinge',
  desc: 'Pflanzliche Rezepte voller Geschmack und Nährstoffe — nie wieder langweilig.'
}, {
  num: '4',
  title: 'Snacks & Desserts',
  desc: 'Schokoladenmousse. Käsekuchen. Kekse. Alles ohne Zucker — so gut, dass niemand den Unterschied merkt.'
}, {
  num: '5',
  title: 'Meal Prep für Unterwegs',
  desc: 'Am Wochenende vorbereiten — die ganze Woche gesund essen, auch wenn die Zeit knapp ist.'
}, {
  num: '6',
  title: 'Wohlbefinden & Balance',
  desc: 'Anti-entzündliche Rezepte für echtes Wohlbefinden — weit über den Teller hinaus.'
}];
export function TomiSection() {
  return <section className="py-8 sm:py-12 px-4 bg-brand-cream" data-id="element-190">
      <div className="max-w-2xl mx-auto" data-id="element-191">
        <div className="text-center mb-6 sm:mb-8" data-id="element-192">
          <h2 className="text-2xl sm:text-3xl font-serif font-bold text-brand-text-main mb-2" data-id="element-193">
            6 Bücher. 500 Rezepte. Ein System.
          </h2>
        </div>

        <div className="space-y-3 sm:space-y-4" data-id="element-194">
          {books.map((b, i) => <div key={i} className="bg-white border border-brand-sage/20 p-4 sm:p-5 rounded-xl flex gap-3 sm:gap-4 items-start shadow-sm" data-id="element-195">
              <div className="bg-brand-olive text-white text-xs font-black px-2.5 py-1 rounded shrink-0 mt-0.5 whitespace-nowrap" data-id="element-196">
                BUCH {b.num}
              </div>
              <div data-id="element-197">
                <h3 className="font-bold text-brand-text-main text-sm sm:text-base mb-1" data-id="element-198">
                  {b.title}
                </h3>
                <p className="text-brand-text-muted text-xs sm:text-sm leading-snug" data-id="element-199">
                  {b.desc}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}